import React from 'react';
import { includes, isArray } from 'lodash';
import { connect } from 'react-redux';
import { removeToast } from '../data/toasts/actions';

import Logger from '../utils/Logger';
import { TOASTS } from '../data/reducer';

let { id: module_id } = module;
const logger = new Logger(module_id);

/**
 * Finds notifications in the state to be shown to the module.
 * Name is usually module_id, this can be extended in future to
 * include modules with certain key, e.g. "./src/component/Component.js:some.key"
 * */
const getToastsForModule = (name, state) => {
  logger.debug(
    'inside getNotificationsForModule, name: [',
    name,
    '], notifications state: ',
    state[TOASTS].data
  );

  let matchingToasts = state[TOASTS].data.filter((item) => {
    let matchingNames = item.modules.filter(
      (moduleName) => moduleName === name
    );
    // we return positive amount of matching names,
    // since notifications can be shown in other modules too.
    return matchingNames.length > 0;
  });

  return matchingToasts;
};

/**
 * Injects a "notifications" prop to the wrapped component.
 * This notifications prop contains an array of notifications
 * to be shown in the component, where the notification spec is
 * usually mapped to an Alert. This implementation is left to the
 * responsibility of the wrapped component.
 *
 * @param {object} options                   Options for the toast hoc
 * @param {string} options.module_id         Module id for the wrapped component
 * @param {array}  [options.dismissOnUnmount]  Array of notification keys to check and
 *                                           dismiss on component unmount
 * @param {React.Component} WrappedComponent Component which the props and lifecycle methods will be passed to
 *
 * */
const ToastHOC = (options, WrappedComponent) => {
  class Wrapper extends React.Component {
    componentWillUnmount() {
      let { dismissToast, toasts } = this.props;

      // check that there are notifications to dismiss
      // and notifications in the state
      if (options.dismissOnUnmount && isArray(toasts)) {
        toasts.forEach((item) => {
          // check whether given keys include the notification's key
          if (includes(options.dismissOnUnmount, item.key)) {
            // dispatch notification dismiss
            dismissToast(item.key);
          }
        });
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state) => {
    return {
      toasts: getToastsForModule(options.module_id, state),
    };
  };

  const mapDispatchToProps = (dispatch) => {
    return {
      dismissToast: (notificationKey) => dispatch(removeToast(notificationKey)),
    };
  };

  return connect(mapStateToProps, mapDispatchToProps)(Wrapper);
};

export default ToastHOC;
